import React from "react";
import { FaSpinner } from "react-icons/fa6";

export default function PasteTab({ pasteText, setPasteText, pasteLoading, handlePaste, pasteSourceUrl, setPasteSourceUrl, pasteSourceType, setPasteSourceType, pastePostedAt, setPastePostedAt, pasteLegalBasis, setPasteLegalBasis, searching }) {
  return (
    <div className="paste-tab" style={{ pointerEvents: searching ? "none" : "auto" }}>
      <div className="paste-card" style={{ pointerEvents: searching ? "none" : "auto" }}>
        <div className="paste-header" style={{ pointerEvents: searching ? "none" : "auto" }}>
          <div className="paste-title" style={{ pointerEvents: searching ? "none" : "auto" }}>📋 Paste & Extract</div>
          <div className="paste-sub" style={{ pointerEvents: searching ? "none" : "auto" }}>Paste public post text from LinkedIn, Google Maps, websites or anywhere — AI extracts leads automatically</div>
        </div>

        <div className="paste-meta-grid" style={{ pointerEvents: searching ? "none" : "auto" }}>
          <div className="paste-meta-item" style={{ pointerEvents: searching ? "none" : "auto" }}>
            <label className="filter-label">SOURCE TYPE</label>
            <select className="filter-select" value={pasteSourceType} onChange={(event) => setPasteSourceType(event.target.value)}>
              {["LinkedIn Public Post", "Website Public Page", "Tender Portal", "Public Directory", "Other Public Source"].map((value) => <option key={value}>{value}</option>)}
            </select>
          </div>
          <div className="paste-meta-item" style={{ pointerEvents: searching ? "none" : "auto" }}>
            <label className="filter-label">POST DATE (optional)</label>
            <input className="filter-input" type="date" value={pastePostedAt} onChange={(event) => setPastePostedAt(event.target.value)} />
          </div>
          <div className="paste-meta-item full-row" style={{ pointerEvents: searching ? "none" : "auto" }}>
            <label className="filter-label">SOURCE URL (optional)</label>
            <input className="filter-input" type="url" placeholder="https://www.linkedin.com/posts/..." value={pasteSourceUrl} onChange={(event) => setPasteSourceUrl(event.target.value)} />
          </div>
          <div className="paste-meta-item full-row" style={{ pointerEvents: searching ? "none" : "auto" }}>
            <label className="filter-label">LEGAL BASIS</label>
            <select className="filter-select" value={pasteLegalBasis} onChange={(event) => setPasteLegalBasis(event.target.value)}>
              {["Legitimate interest (B2B)", "Consent", "Contract pre-sales"].map((value) => <option key={value}>{value}</option>)}
            </select>
          </div>
        </div>

        <textarea
          className="paste-area"
          placeholder="Paste public opportunity text, company info, LinkedIn post text, search results, business directories…"
          value={pasteText}
          onChange={(event) => setPasteText(event.target.value)}
          rows={12}
        />
        <button className="btn-search" onClick={handlePaste} disabled={pasteLoading || !pasteText.trim()}>
          {pasteLoading ? <span><FaSpinner className="spin" /> Extracting…</span> : "🤖 Extract Leads with AI"}
        </button>
      </div>
    </div>
  );
}